
define('text!plugins/editorialwindow/setupTemplate.html',[],function () { return '';});

